import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PagesComponent } from './pages/pages.component';
import { authGuard } from './guard/auth.guard';

export const routes: Routes = [

  {
    path: '',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.routes').then((m) => m.routes),
    pathMatch: 'prefix',
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: {
      meta: {
        title: 'Login',
      },
    },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
    data: {
      meta: {
        title: 'Forgot Password',
      },
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      meta: {
        title: 'Page not found | PACAAP',
      },
    },
  },
];
